var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeacher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m380.42 272.25-2.64 23.75-1.78 16h-224l-1.78-16-2.64-23.75a123.092 123.092 0 0 1 9.2-62.07 123.208 123.208 0 0 0 9.8-54.63l-1.39-27.68a98.933 98.933 0 1 1 197.62 0l-1.39 27.68a123.208 123.208 0 0 0 9.8 54.63 123.028 123.028 0 0 1 9.2 62.07z",
    fill: "#8f4d2e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m380.42 272.25-2.64 23.75h-89.78v-88l16-32v-64a88.087 88.087 0 0 0 -64.74-84.89 99.043 99.043 0 0 1 123.55 100.76l-1.39 27.68a123.208 123.208 0 0 0 9.8 54.63 123.028 123.028 0 0 1 9.2 62.07z",
    fill: "#82462a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m307.2 280a11.194 11.194 0 0 1 -11.2-11.2v-52.8h-64v52.8a11.194 11.194 0 0 1 -11.2 11.2h-12.8v48h112v-48z",
    fill: "#fec9a3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m268.824 256a43.894 43.894 0 0 0 27.176-9.807v-30.193h-64v30.19a43.894 43.894 0 0 0 27.176 9.81z",
    fill: "#feb784"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m336 128v40a72 72 0 0 1 -144 0v-40a108.535 108.535 0 0 0 36.9-41.8l3.1-6.2 4.54 3.79a199.241 199.241 0 0 0 67.46 36.9 199.509 199.509 0 0 0 32 7.31z",
    fill: "#fec9a3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m336 128v40a72.035 72.035 0 0 1 -58.26 70.69 87.683 87.683 0 0 0 26.26-62.69v-55.31a199.509 199.509 0 0 0 32 7.31z",
    fill: "#fec093"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m228 160a12 12 0 1 1 12-12 12.013 12.013 0 0 1 -12 12z",
    fill: "#7a432a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m300 160a12 12 0 1 1 12-12 12.013 12.013 0 0 1 -12 12z",
    fill: "#7a432a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m264 200a24.027 24.027 0 0 1 -24-24h16a8 8 0 0 0 16 0h16a24.027 24.027 0 0 1 -24 24z",
    fill: "#f7a468"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m224 312h80v56h-80z",
    fill: "#e0e0de"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m426.97 487.67a24.282 24.282 0 0 1 -26.97-16.11l-52.84-99.13a62.3 62.3 0 0 1 -11.16 59.57v64h-144v-64a62.4 62.4 0 0 1 -11.04-60.31l-53.7 99.87a24.273 24.273 0 0 1 -46.09-15.24l58.74-146.21a47.985 47.985 0 0 1 44.54-30.11h31.55l48 88 48-88h31.43a48.041 48.041 0 0 1 44.6 30.27l58.07 146.05a24.287 24.287 0 0 1 -19.13 31.35z",
    fill: "#ec8c8c"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m74.23 459.01 5.77-75.01h48v77.075a26.925 26.925 0 0 1 -26.925 26.925 26.924 26.924 0 0 1 -26.845-28.99z",
    fill: "#f59898"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m98.821 267.3a15.562 15.562 0 0 0 -10.145 22.057l7.324 14.643h-28.669a48 48 0 0 1 -21.466-5.067l-7.972-3.986a9.6 9.6 0 0 0 -13.893 8.586v22.578a16 16 0 0 0 8.845 14.311l13.02 6.511a48 48 0 0 0 21.466 5.067h60.669v-48l-10.955-27.387a15.562 15.562 0 0 0 -18.224-9.313z",
    fill: "#fec9a3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m80 352h48v32h-48z",
    fill: "#e0e0de"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m426.97 487.67a24.282 24.282 0 0 1 -26.97-16.11l-52.84-99.13a62.3 62.3 0 0 1 -11.16 59.57v64h-141.37c66.03-43.12 121.74-97.84 168.5-211.76a47.923 47.923 0 0 1 24.9 26.03l58.07 146.05a24.287 24.287 0 0 1 -19.13 31.35z",
    fill: "#e07f7f"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m376 464-80-16v-112l80 16z",
    fill: "#a36548"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m408 464 80-16v-112l-80 16z",
    fill: "#8f4d2e"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m376 352h32v112h-32z",
    fill: "#95573a"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m392 352a28.332 28.332 0 0 0 -23.673-27.946l-72.327-12.054v24l80 16h16a28.332 28.332 0 0 1 23.673-27.946l72.327-12.054v24l-80 16z",
    fill: "#d4bd81"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m473.315 463.237-32 5.334a8 8 0 0 1 -9.315-7.891v-29.735a10.413 10.413 0 0 1 8.7-10.272l27.172-4.529a10.414 10.414 0 0 1 12.128 10.273v28.929a8 8 0 0 1 -6.685 7.891z",
    fill: "#fec9a3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacher);
export default __webpack_public_path__ + "static/media/teacher.73777c00390c9a9ba082f94de19d007a.svg";
export { ForwardRef as ReactComponent };